{
  "title": "Messages",
  "nav": {
    "label": "Messages",
    "unread": "{{unreadValue}} message(s) non lu(s)"
  },
  "list": {
    "empty": "Vous n'avez aucune conversation.",
    "includeArchived": "Afficher les archivées",
    "noMessage": "Aucun message pour l'instant.",
    "unknownParticipant": "Compte supprimé"
  },
  "thread": {
    "empty": "Écrivez le premier message de cette conversation."
  },
  "search": {
    "label": "Rechercher dans la conversation",
    "placeholder": "Un mot du message…",
    "results_one": "{{count}} message trouvé",
    "results_other": "{{count}} messages trouvés",
    "empty": "Aucun message ne contient « {{query}} »."
  },
  "message": {
    "deleted": "Message supprimé",
    "edited": "modifié",
    "delete": "Supprimer",
    "report": "Signaler",
    "hidden": "Message retiré par la modération"
  },
  "link": {
    "title": "Lien externe",
    "destination": "Ce lien quitte Teach pour {{host}}.",
    "open": "Ouvrir le lien",
    "cancel": "Annuler"
  },
  "composer": {
    "label": "Votre message",
    "placeholder": "Écrire un message…",
    "send": "Envoyer",
    "closed": "Cette conversation est en lecture seule : aucune inscription ne vous lie plus à cette personne."
  },
  "actions": {
    "mute": "Mettre en sourdine",
    "unmute": "Réactiver les avis",
    "archive": "Archiver",
    "unarchive": "Désarchiver"
  }
}
